<template>
    <div class="submitWrapper paddBottom">
        <IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
        <div class="main">
            <div class="conner">
                <div class="h1">{{submitTitle}}</div>
                <div class="desc" v-if="!editstate">
                    {{submitDesc}}
                </div>
                <div class="tabList">
                    <div :class="activeName == 'form' ? 'isActive tab' : 'tab'" @click="activeName = 'form'">
                        form
                    </div>
                    <div :class="activeName == 'template' ? 'isActive tab' : 'tab'" @click="activeName = 'template'"
                         v-if="!editstate">
                        Email submission instructions
                    </div>
                </div>
                <div class="formSubMain" v-if="activeName == 'form'">
                    <el-form ref="myForm" :model="form" :rules="rules">
                        <el-form-item label="Title:" :required="true" prop="title">
                            <el-input v-model="form.title" placeholder="Please enter the Title"
                                      v-bind:disabled="editstate"></el-input>
                        </el-form-item>
                        <el-form-item label="Object_name:" prop="objectName">
                            <el-input v-model="form.objectName" placeholder="Please enter the Object_name"
                                      v-bind:disabled="editstate"></el-input>
                        </el-form-item>
                        <el-form-item label="Object_Class:" prop="objectClass">
                            <el-select v-model="form.objectClass" filterable placeholder="Please choose"
                                       v-bind:disabled="editstate">
                                <el-option v-for="(item, index) in objectClassList" :key="index" :label="item.name"
                                           :value="item.name"></el-option>
                            </el-select>
                        </el-form-item>

                        <!--	<el-form-item label="Event_Name:">
                                <el-select
                                                       style="width:100%"
                                                       v-model="form.objectName"
                                                       clearable
                                                       filterable
                                                       placeholder="Variables"
                                                       v-selectLoadMore="selectLoadMore"
                                                       :loading="loading"
                                                       remote
                                                       class="objectName"
                                                       :remote-method="remoteMethod"
                                                       @change="changeValue"
                                                       >
                                              <el-option v-for="item in options" :key="item.value" :label="item.name"
                                                  :value="item.name">
                                              </el-option>
                                            </el-select>
                            </el-form-item>
                        -->
                        <el-form-item label="Telescope:" prop="telescope">
                            <el-select v-model="form.telescope" filterable placeholder="Variables" allow-create
                                       class="objectName" style="width: 100%" v-bind:disabled="editstate">
                                <el-option v-for="item in telescopeList" :key="item.value" :label="item.name"
                                           :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Trigger_Time:" prop="triggerTime">
                            <el-date-picker v-model="form.triggerTime" type="datetime"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="eg:2022-11-11 12:00:00" :picker-options="pickerOptions0"
                                            v-bind:disabled="editstate">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Ra:" prop="ra">
                            <el-input v-model="form.ra" placeholder="(e.g. 350.12)"
                                      v-bind:disabled="editstate"></el-input>
                        </el-form-item>
                        <el-form-item label="DEC:" prop="declination">
                            <el-input v-model="form.declination" placeholder="(e.g. -17.33)"
                                      v-bind:disabled="editstate"></el-input>
                        </el-form-item>
                        <el-form-item label="Error:" prop="positioningError">
                            <el-input v-model="form.positioningError" placeholder="(e.g. -17.33)"
                                      v-bind:disabled="editstate"></el-input>
                        </el-form-item>
                        <!--						上传文件改造 start-->
                        <el-form-item label="Related_files:">
                            <div class="Add" @click="addRelated_files" v-if="!editstate">ADD +</div>
                            <span style="color: red;display: inline-block; margin-left: 20px;" v-if="!editstate">Click here to add an image or URL</span>
                            <div v-for="(item, index) in related_filesList" :key="index">
                                <el-radio-group v-model="item.checkList" size="mini">
                                    <el-radio label="Picture" border v-if="!editstate">File</el-radio>
                                    <el-radio label="Picture URL" border v-if="!editstate">URL</el-radio>
                                </el-radio-group>
<!--                                <div class="Add" @click="handleRemovedelete(index)" v-if="related_filesList.length > 1">DELETE</div>-->
                                <el-button type="text" icon="el-icon-delete" circle @click="handleRemovedelete(index)" v-if="related_filesList.length > 1"></el-button>
                                <!--                                url-->
                                <el-form-item label="URL:" v-if="item.checkList == 'Picture URL'">
                                    <div class="url_item">
                                        <el-input v-model="item.url" style="width: 388px"
                                                  placeholder="http://" v-bind:disabled="editstate"></el-input>
                                    </div>
                                </el-form-item>
                                <div>
                                    <!--                                picture-->
                                    <el-form-item label="Picture:" v-if="item.checkList == 'Picture'">

                                        <el-upload
                                                :action="actionUrl"
                                                class="avatar-uploader"
                                                :show-file-list="false"
                                                :on-preview="(file) => {return handlePictureCardPreview(file,item)}"
                                                :on-remove="(file) => {return handleRemove(file)}"
                                                :on-success="(response, file, fileList)=>{return upload_success(response, file, fileList,item)}"
                                                v-bind:disabled="editstate">
                                            <img v-if="item.url!=''" :src="item.url" class="avatar">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>


                                    </el-form-item>
                                    <!--                                caption-->
                                    <el-form-item label="Caption:">
                                        <el-input v-model="item.caption"
                                                  placeholder="Please enter the Caption"
                                                  v-bind:disabled="editstate"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                        </el-form-item>
                        <!--						上传文件改造 end-->
                        <el-form-item label="Email:">
                            <el-input v-model="form.email" placeholder="Please enter the Email" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="Comments:">
                            <quill-editor :options="editorOption" v-model="form.comments" v-bind:disabled="editstate">
                            </quill-editor>
                        </el-form-item>
                        <!--						<el-form-item label=" ">-->
                        <!--							<div class="flexWrap">-->
                        <!--								<el-input v-model="form.attachmentName" style="width: 388px" disabled-->
                        <!--									placeholder="Please select a file to upload"></el-input>-->
                        <!--								<div>-->
                        <!--									<el-upload class="upload-demo" :action="actionUrl" :on-success="upload_successfile"-->
                        <!--										:on-error="upload_errorfile" multiple>-->
                        <!--										<el-button size="small" type="primary" class="btn QSe">Select</el-button>-->
                        <!--									</el-upload>-->
                        <!--								</div>-->
                        <!--							</div>-->
                        <!--						</el-form-item>-->
                        <el-form-item style="margin: 40px 0" v-if="!editstate">
                            <div class="flexCenter">
                                <div class="cancel" @click="cancelForm">Cancel</div>
                                <div class="submit" @click="onSubmit('myForm')">Submit</div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-else style="width: 701px; margin: 0 auto">
                    <div class="oneCard">
                        <!-- <div v-html="description" style="overflow-x: hidden;"></div> -->
                        <!-- {{description}} -->
                        <h3 style="font-size: 30px;">Email submission instructions</h3>
                        <div style="font-size: 20px;">
                            AstroBurstHub is the abbreviation for Astronomical Burst Hub, which is designed to get
                            together all astronomical burst
                            <router-link to="/Events" style="color: #168EC7;">Events</router-link>
                            , such as Gamma-Ray Burst (GRB), Soft Gamma-ray Repeater (SGR), Fast Radio Burst (FRB),
                            Gravitational Wave (GW) and High Energy Neutrino (HEN), from various platforms which collect
                            and distribute
                            <router-link to="/message" style="color: #168EC7;">Messages</router-link>
                            publicly. These platforms include Gamma-ray Coordinates Network (GCN), The Astronomer's
                            Telegram (ATEL), and other public resources.
                        </div>
                        <div style="font-size: 20px;margin-top: 20px;">
                            In the era of multi-messenger multi-wavelength astronomy, it is of critical importance to
                            make joint observations with various telescopes and instruments in a timely manner. These
                            observations usually will be reported as various types of Messages in different platforms,
                            which is somewhat inconvenient for researchers. We collect these Messages from various
                            platform and group them into astronomical burst Events. An Event corresponds to a burst
                            activity of the celestial object, which may be observed by one or multiple telescopes and
                            instruments. Observations of an Event may result in one or multiple Messages. We also
                            provide statistics of all and the latest Events and Messages and highlight the most popular
                            Events (called Hot Events). We hope this website will provide helpful information to
                            researcher and facilitate the study of astronomical bursts.
                        </div>
                        <div style="font-size: 20px;margin-top: 20px;">
                            The purpose of establishing this "AstroBurstHub" website is solely for opened scientific
                            research and public interest. All Messages are collected from public platforms and
                            resources. We sincerely thank all authors and platforms who shared their Messages publicly.
                            All copyrights and credits should be given to the original authors and platforms of these
                            Messages.
                        </div>
                        <div style="font-size: 20px;margin-top: 20px;">
                            In this website, all information and links are given for reference purpose only, and we
                            explicitly state that any responsibility for damage, loss or injury is excluded which a
                            person or institution may experience while using these information or links. 
                        </div>
                        <div style="font-size: 20px;margin-top: 20px;">
                            This website is fully open for collaboration. Should you have any comment and suggestion,
                            please do not hesitate to contact us.
                        </div>
                    </div>
                    <!--					<div class="templateDesc">-->
                    <!--&lt;!&ndash;						{{tpl}}&ndash;&gt;-->
                    <!--					</div>-->
                    <!--					<div class="line"></div>-->
                    <!--					<div class="download">-->
                    <!--						<div class="label">Template download:</div>-->
                    <!--						<div class="file">-->
                    <!--							<i class="el-icon-folder-opened"></i>-->
                    <!--							<span>CustomizeTemplate.xlsx</span>-->
                    <!--						</div>-->
                    <!--						<div class="btn lv" @click="getExcel">DOWNLOAD</div>-->
                    <!--					</div>-->
                    <!--					<div class="line"></div>-->
                    <!--					<div class="upload">-->
                    <!--						<div class="temUpload">-->
                    <!--							<div class="label" style="margin-right: 15px">-->
                    <!--								Template download:-->
                    <!--							</div>-->
                    <!--							<el-input v-model="formTwo.tpl.name" style="width: 388px" disabled-->
                    <!--								placeholder="Please select a file to upload"></el-input>-->
                    <!--							<el-upload class="upload-demo2" :auto-upload="false" :on-change="changeUploadTemplate"-->
                    <!--								:action="actionUrl" multiple :limit="1" :on-exceed="upload_exceed">-->
                    <!--								<el-button size="small" type="primary" class="btn QSe">Select</el-button>-->
                    <!--							</el-upload>-->
                    <!--						</div>-->
                    <!--						<div class="attach">-->
                    <!--							<div class="label" style="margin-right: 15px">Attachment:</div>-->
                    <!--							<el-input v-model="formTwo.attachment.name" style="width: 388px" disabled-->
                    <!--								placeholder="Please select a file to upload"></el-input>-->
                    <!--							<el-upload class="upload-demo2" :auto-upload="false" :action="actionUrl"-->
                    <!--								:on-change="changeUpload" multiple :limit="1" :on-exceed="upload_exceed">-->
                    <!--								<el-button size="small" type="primary" class="btn QSe">Select</el-button>-->
                    <!--							</el-upload>-->
                    <!--						</div>-->
                    <!--						<div class="flexCenter" style="margin-top: 30px; margin-bottom: 50px">-->
                    <!--							<div class="cancel">Cancel</div>-->
                    <!--							<div class="submit" @click="onSubmitTwo">Submit</div>-->
                    <!--						</div>-->
                    <!--					</div>-->
                </div>
            </div>
        </div>
        <!-- 弹窗部分 -->
        <el-dialog :visible.sync="dialogVisible" :title="dialogTitle"
                   :close-on-click-modal="false"
                   :before-close="handleBeforeClose">
            <el-form ref="dialogForm" :model="newUserFormData">
                <el-form-item label="The purpose of issuing the alert：">
                    <el-input v-model="newUserFormData.objective" v-bind:disabled="showUpSubmitAprove"></el-input>
                </el-form-item>

                <el-form-item label="Owning device：">
                    <el-input v-model="newUserFormData.device" v-bind:disabled="showUpSubmitAprove"></el-input>
                </el-form-item>

                <!--                <el-form-item label="Belongs to the task group：">-->
                <!--                    <el-input v-model="newUserFormData.taskForce"></el-input>-->
                <!--                </el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDialogSubmit" v-if="showUpSubmit">Save and continue</el-button>
              <el-button type="warning" v-if="showUpSubmitAprove">Wait for approval</el-button>
              <el-button type="success" v-if="showApproveDone">Approved</el-button>
      </span>
        </el-dialog>
        <!--        <el-dialog :visible.sync="dialogVisible">-->
        <!--            <img width="100%" :src="dialogImageUrl" alt=""/>-->
        <!--        </el-dialog>-->
    </div>
</template>
<script>
    import Vue from "vue";
    import qs from "qs";
    import axios from "axios";
    import IndexHeaderOthers from "../components/header/indexHeaderOthers.vue";
    // import axios from "axios";
    var instance = axios.create({
        baseURL: process.env.VUE_APP_BASE_API,
        timeout: 100000,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    // Vue.config.productionTip=false;


    // Vue.prototype.instance=instance;
    export default {
        name: "indexPage",
        components: {
            IndexHeaderOthers,
        },
        data() {
            var openCheck = (rule, value, callback) => {
                if (!value) {
                    this.$message.error('This contents cannot be empty!');
                } else {
                    callback();
                }
            };

            //校验值
            var checkRaInfo = (rule, value, callback) => {
                let flags = false;
                const positiveIntegerRegex = /^[1-9]\d*$/;
                const negativeIntegerRegex = /^-[1-9]\d*$/;
                const positiveDecimalRegex = /^[1-9]\d*\.\d+|0\.\d*[1-9]\d*$/;
                const negativeDecimalRegex = /^-([1-9]\d*\.\d+|0\.\d*[1-9]\d*)$/;
                if (positiveIntegerRegex.test(value)) {
                    flags = true;
                } else if (negativeIntegerRegex.test(value)) {
                    flags = true;
                } else if (positiveDecimalRegex.test(value)) {
                    flags = true;
                } else if (negativeDecimalRegex.test(value)) {
                    flags = true;
                } else {
                    flags = false;
                }
                if (!value) {
                    this.$message.error('This contents cannot be empty!');
                } else {
                    if (!flags) {
                        this.$message.error('Please enter a number!');
                    } else {
                        callback();
                    }
                }
            };
            return {
                editorOption: {
                    placeholder: 'please enter the Comments'
                },
                editstate: false,
                activeName: "form",
                pickerOptions0: {
                    disabledDate: (time) => {
                        const start = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
                            1000 - 1);
                        return time.getTime() >
                            new Date().getTime() + (start - new Date().getTime());
                    }
                },
                // actionUrl: process.env.VUE_APP_BASE_API + "/cms-middle/astronCustomize/upload?uploadPath=/astron/customize",
                // actionUrl: process.env.VUE_APP_ENV + "/cms-middle/astronCustomize/webupload/upload?uploadPath=/astron/customize",
                actionUrl: process.env.VUE_APP_BASE_ENV + "/cms-middle/astronCustomize/webupload/upload?uploadPath=/astron/customize",
                urlList: [{
                    url: "",
                },],
                related_filesList: [{
                    checkList: "Picture",
                    caption: "",
                    url: "",
                }],
                dialogImageUrl: "",
                dialogVisible: false,
                disabled: true,
                objectClassList: [],
                telescopeList: [],
                form: {
                    title: "",
                    objectClass: "",
                    objectName: "",
                    telescope: "",
                    triggerTime: "",
                    ra: '',
                    declination: "",
                    email: "",
                    positioningError: "",
                    comments: "",
                    attachment: "",
                    checkList: "Picture",
                    caption: "",
                    attachmentName: '',
                    lcUrl: ''
                },
                rules: {
                    title: [
                        {required: true, message: 'The title cannot be empty', trigger: 'blur'}
                        // {required: true, validator: openCheck, trigger: 'blur' }
                    ],
                    objectClass: [
                        {required: true, message: 'The objectClass cannot be empty', trigger: 'blur'}
                        // {required: true, validator: openCheck, trigger: 'blur' }
                    ],
                    objectName: [
                        {required: true, message: 'The objectName cannot be empty', trigger: 'blur'}
                        // {required: true, validator: openCheck, trigger: 'blur' }
                    ],
                    telescope: [
                        // { required: true, message: 'The telescope cannot be empty', trigger: 'blur'}
                        {required: true, validator: openCheck, trigger: 'blur'}
                    ],
                    triggerTime: [
                        {required: true, message: 'The triggerTime cannot be empty', trigger: 'blur'}
                        // {required: true, validator: openCheck, trigger: 'blur' }
                    ],
                    ra: [
                        // { required: true, message: 'The ra cannot be empty', trigger: 'blur'}
                        {required: true, validator: checkRaInfo, trigger: 'blur'}
                    ],
                    declination: [
                        // { required: true, message: 'The declination cannot be empty', trigger: 'blur'}
                        {required: true, validator: checkRaInfo, trigger: 'blur'}
                    ],
                    email: [
                        // { required: true, message: 'The email cannot be empty', trigger: 'blur'}
                        {required: true, validator: openCheck, trigger: 'blur'}
                    ],
                    positioningError: [
                        // { required: true, message: 'The positioningError cannot be empty', trigger: 'blur'}
                        {required: true, validator: checkRaInfo, trigger: 'blur'}
                    ],
                },
                formTwo: {
                    attachment: "",
                    tpl: "",
                },
                imgList: [],
                options: [],
                submitDesc: '',
                submitTitle: '',
                tpl: '',
                tplUrl: '',
                search: {
                    pageNum: 1,
                    pageSize: 10,
                },
                newUserFormData: {
                    objective: '',
                    device: '',
                    taskForce: '',
                    loginName: '',
                    email: '',
                    name: ''
                },
                dialogTitle: 'Complete user information',
                urlListNew: [],
                tagsListNew: [],
                showUpSubmit: true,
                showUpSubmitAprove: false,
                showApproveDone: false,
            };
        },
        mounted() {
            //获取参数
            const id = this.$route.query.constid;
            if (id == undefined || id == '') {
                this.editstate = false;
            } else {
                this.getRetData(id);
            }
            // window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
            this.submitDesc = JSON.parse(localStorage.getItem('columnDetail')).submitDesc.description
            this.submitTitle = JSON.parse(localStorage.getItem('columnDetail')).submitTitle.description
            this.tpl = JSON.parse(localStorage.getItem('columnDetail')).tpl.description
            this.tplUrl = process.env.VUE_APP_ENV + JSON.parse(localStorage.getItem('columnDetail')).tplUrl.description
            if (localStorage.getItem('userInfo') == null) {
                this.form.email = '';
            } else {
                this.form.email = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
            }
            this.getData();
        },
        methods: {
            // 下载模板
            getExcel() {
                // this.$http
                //   .get("/cms/astronCustomize/import/template")
                //   .then((res) => {
                //     console.log(res);
                //     if (res.status == 200) {
                //       this.$message.info("Get successfully");
                //     } else {
                //       this.$message.error(res.data.msg);
                //     }
                //   })
                //   .catch((err) => {
                //     this.$message.error(err);
                //   });
                window.location.href = this.tplUrl
            },
            changeValue(e) {
                this.form.objectName = e
            },
            changeFile(file, item) {
                if (item.url != '') {
                    item.url = file.url
                }
            },
            selectLoadMore() {
                this.search.pageNum = this.search.pageNum + 1;
                if (this.search.pageNum > this.totalPage) return;
                this.readAllUsers(); // 请求接口
            },
            remoteMethod(query) {
                this.loading = true;
                this.search.query = query;
                this.search.pageNum = 1;
                this.options = [];
                setTimeout(() => {
                    this.loading = false;
                    this.readAllUsers(); // 请求接口
                }, 200)
            },
            readAllUsers() {
                this.$fetchGet("cms-middle/astronTag/list?pageNo=" + this.search.pageNum + '&pageNum=' + this.search.pageSize + '&type=event_name' + '&name=' + this.search.query)
                    .then(res => {
                        console.log(res)
                        if (res.page.records.length == 0) {
                            this.$message.success("no data");
                            this.options = []
                        } else {
                            for (var i = 0; i < res.page.records.length; i++) {
                                this.options.push(res.page.records[i])
                            }
                            for (var i = 0; i < this.options.length; i++) {
                                if (this.options[i].checked) {
                                    if (this.options[i].checked == 'checked') {
                                        this.subscribedGroup.push(this.options[i])
                                        this.subscribedGroupArray.push(this.options[i].id)
                                    }
                                }
                            }
                        }
                    })
            },
            getData(name) {
                // debugger;
                this.$fetchGet("/cms-middle/member/subscribe")
                    .then((res) => {
                        this.objectClassList = res.data.object_class
                        for (var i = 0; i < res.data.telescope.length; i++) {
                            // console.log(res.data.telescope[i].children)
                            this.telescopeList.push(...res.data.telescope[i].children)
                        }
                        // console.log(this.telescopeList)
                    })
                    .catch((err) => {
                    });
            },
            // 下载模板
            getTimes() {
                const myDate = new Date(); //实例一个时间对象；
                myDate.getHours(); //获取系统时，
                myDate.getMinutes(); //分
                myDate.getSeconds(); //秒
                let a =
                    myDate.getHours() +
                    ":" +
                    myDate.getMinutes() +
                    ":" +
                    myDate.getSeconds();
                return "00:00:00" + "-" + a; // 限制到秒
            },
            changeUploadTemplate(file) {
                this.formTwo.tpl = file.raw;
            },
            changeUpload(file) {
                this.formTwo.attachment = file.raw;
            },
            upload_success(response, file, fileList, item) {
                item.url = process.env.VUE_APP_BASE_DOWNLAD + response.url;
                this.imgList.push(process.env.jj + response.url);
            },

            upload_errorfile(err, file, fileList) {
                // console.log(err, file, fileList);
            },

            upload_errorfile_template(err, file, fileList) {
                // console.log(err, file, fileList);
            },

            upload_errorfile_attach(err, file, fileList) {
                // console.log(err, file, fileList);
            },
            upload_exceed(files, fileList) {
                // console.log(fileList)
                this.$message.error("Only one upload is allowed");
            },
            getObjectUrl(file) {
                let url = null;
                console.log(window.URL.createObjectURL);
                if (window.createObjectURL != undefined) {
                    // basic
                    url = window.createObjectURL(file);
                } else if (window.webkitURL != undefined) {
                    // webkit or chrome
                    url = window.webkitURL.createObjectURL(file);
                } else if (window.URL != undefined) {
                    // mozilla(firefox)
                    url = window.URL.createObjectURL(file);
                }
                return url;
            },
            handleRemove(file, item) {
                // let uploadFiles = this.$refs.pictureUpload.uploadFiles;
                // for (var i = 0; i < uploadFiles.length; i++) {
                //     if (uploadFiles[i]["url"] == file.url) {
                //         uploadFiles.splice(i, 1);
                //         this.imgList.splice(i, 1);
                //     }
                // }
            },
            handleRemovedelete(index) {
                this.related_filesList.splice(index, 1);
            },
            handlePictureCardPrevie2(item) {
                return () => {
                    // console.log("这是数据:",item);
                }
            },
            handlePictureCardPreview(file, item) {
                // console.log("这是数据：",item);
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            onSubmitTwo() {
                let formdatas = new FormData();
                if (this.formTwo.attachment != "") {
                    formdatas.append("attachment", this.formTwo.attachment);
                }
                if (this.formTwo.tpl != "") {
                    formdatas.append("tpl", this.formTwo.tpl);
                }
                instance
                    .post("/cms-middle/astronCustomize/saveFile", formdatas)
                    .then((res) => {
                        this.$message.success("Submitted successfully");
                        this.formTwo = {
                            attachment: "",
                            tpl: "",
                        };
                    })
                    .catch((err) => {
                        this.$message.error(err);
                    });
            },
            //测试
            onSubmit: function (from) {
                this.$refs.myForm.validate((valid) => {
                    if (valid) {
                        this.submit();
                    } else {
                        this.$message.error("The form data is incorrect");
                        return false;
                    }
                });
            },

            //数据提交修改
            submit() {
                //提交数据：
                if (!localStorage.getItem("access_token")) {
                    this.$message.error("Please log in to the system to do so");
                    return false;
                }
                //检查用户是否存在
                this.$http
                    .get("/sys/user/checkUserInfo?username=" + JSON.parse(localStorage.getItem('userInfo')).cstnetId)//+ JSON.parse(localStorage.getItem('userInfo')).cstnetId
                    .then((res) => {
                        // console.log("这是数据返回值：",res);
                        if (res.data.status) {
                            // if (!res.data.status) {
                            //     this.dialogVisible = true;
                            //     this.newUserFormData.loginName = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
                            //     this.newUserFormData.email = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
                            //     this.newUserFormData.name = JSON.parse(localStorage.getItem('userInfo')).truename;
                            //     this.form.status = 5;
                            //     return;
                            // }

                            //-------end
                            let json = {};
                            for (let i in this.form) {
                                if (this.form[i] != "") {
                                    json[i] = this.form[i];
                                }
                            }
                            let picurl = "";
                            if (this.form.checkList == "Picture URL") {
                                let result = [];
                                for (let i in this.urlList) {
                                    result.push(this.urlList[i].url);
                                }
                                this.form.lcUrl = result.join(",");
                            } else {
                                this.form.lcUrl = this.imgList.join(",");
                            }
                            let caption = "";
                            let capResult = [];
                            for (let i in this.related_filesList) {
                                capResult.push(this.related_filesList[i].caption);
                            }
                            this.form.caption = capResult.join(",");
                            let urlMap = JSON.stringify(this.related_filesList);
                            this.form.lcUrl = urlMap;
                            let a = qs.stringify(this.form);
                            // console.log(this.form.objectClass)
                            // return false
                            this.$http
                                .post("/cms-middle/astronCustomize/savebyUser?" + qs.stringify(this.form))
                                .then((res) => {
                                    if (res.status == 200) {
                                        this.$message.success("Submitted successfully");
                                        this.form = {
                                            title: "",
                                            objectClass: "",
                                            objectName: "",
                                            telescope: "",
                                            triggerTime: "",
                                            ra: "",
                                            declination: "",
                                            email: "",
                                            positioningError: "",
                                            comments: "",
                                            attachment: "",
                                            lcUrl: '',
                                            checkList: "Picture",
                                            attachmentName: '',
                                            caption: ''
                                        };
                                        this.imgList = [];
                                        this.related_filesList = [{
                                            checkList: "Picture",
                                            caption: "",
                                            url: '',
                                        }];
                                        this.urlList = [{
                                            url: "",
                                        }];

                                        const mainImg = this.$refs.pictureUpload;
                                        if (mainImg && mainImg.length) {
                                            mainImg.forEach(item => {
                                                item.clearFiles();
                                            });
                                        }
                                        this.$router.push("submitList");
                                    } else {
                                        this.$message.error(res.data.msg);
                                        this.$router.push("/indexPage");
                                    }
                                })
                                .catch((err) => {
                                    this.$message.error(err);
                                });
                        } else {
                            //这是开始
                            this.$confirm('You have not completed the user information, please complete the user information', 'Prompt', {
                                confirmButtonText: 'OK',
                                cancelButtonText: 'CANCEL',
                                type: 'warning'
                            }).then(() => {

                                this.dialogVisible = true;
                                this.newUserFormData.loginName = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
                                this.newUserFormData.email = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
                                this.newUserFormData.name = JSON.parse(localStorage.getItem('userInfo')).truename;
                                //回显数据
                                let token = localStorage.getItem('access_token')
                                if (!token) {
                                    this.dialogVisible = true;
                                } else {
                                    this.userinfoDialogVisible = true;
                                    this.newUserFormData.loginName = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
                                    this.newUserFormData.email = JSON.parse(localStorage.getItem('userInfo')).cstnetId;
                                    this.newUserFormData.name = JSON.parse(localStorage.getItem('userInfo')).truename;
                                    //获取用户信息
                                    this.$fetchPost("/cms-middle/astronCustomize/getUserInfoByEmail?userEmail=" + JSON.parse(localStorage.getItem('userInfo')).cstnetId)
                                        // this.$fetchPost("/cms-middle/astronCustomize/getUserInfoByEmail?userEmail=1156522566@qq.com")
                                        .then(result => {

                                            if (result.status == 2) {
                                                this.newUserFormData.objective = result.user.objective;
                                                this.newUserFormData.device = result.user.device;
                                                this.showUpSubmit = false;
                                                this.showUpSubmitAprove = false;
                                                this.showApproveDone = true;
                                            } else if (result.status == 0) {
                                                //表示没有
                                                this.showUpSubmit = true;
                                                this.showUpSubmitAprove = false;
                                                this.showApproveDone = false;
                                            } else {
                                                this.showUpSubmit = false;
                                                this.showUpSubmitAprove = true;
                                                this.showApproveDone = false;
                                                this.newUserFormData.objective = result.user.objective;
                                                this.newUserFormData.device = result.user.device;
                                            }
                                        })
                                        .catch(err => {
                                        });
                                }
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: 'Canceled'
                                });
                            });
                        }
                    })
            },

            cancelForm() {
                this.form.title = '';
                this.form.objectClass = '';
                this.form.objectName = '';
                this.form.telescope = '';
                this.form.triggerTime = '';
                this.form.ra = '';
                this.form.positioningError = '';
                this.form.comments = '';
                this.form.attachment = '';
                this.form.lcUrl = '';
                this.form.checkList = '';
                this.form.attachmentName = '';
                this.form.caption = '';
                this.related_filesList = [{
                    checkList: "Picture",
                    caption: "",
                    url: "",
                }];
                this.$router.push("/indexPage");
            },
            addUrl() {
                this.urlList.push({
                    url: "",
                });
            },
            removeUrl(e, index) {
                this.urlList.splice(index, 1);
            },
            addRelated_files() {
                this.related_filesList.push({
                    checkList: "Picture",
                    url: "",
                    caption: "",
                })
            },
            handleDialogSubmit() {
                // 提交新用户信息表单
                this.$refs.dialogForm.validate(valid => {
                    if (valid) {
                        this.$http
                            .post("/sys/user/submitSave?" + qs.stringify(this.newUserFormData))
                            .then((res) => {
                                    this.$message.success("Submitted successfully");
                                    this.dialogVisible = false;
                                }
                            );
                    } else {
                        console.log('Form validation failed');
                    }
                });
            },
            handleBeforeClose(done) {
                // 弹出确认对话框
                this.$confirm('If the user information is not filled in completely, you cannot submit the user, are you sure you want to close the current interface?', 'Prompt', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    // 用户点击了确定，关闭对话框并执行done回调
                    done();
                })
            },

            //数据回显
            getRetData(dataId) {
                this.$fetchGet("/cms-middle/astronCustomize/queryById1", {
                    id: dataId,
                }).then((res) => {
                    this.form = res.astronCustomize.data;
                    this.related_filesList = res.astronCustomize.urlsList;
                    this.tagsListNew = res.astronCustomize.tagsList;
                    if (this.form.status == '5') {
                        this.editstate = false;
                    } else {
                        this.editstate = true;
                    }
                    // this.urlListNew.forEach((item) =>{
                    //   this.imgList.push(item);
                    // });
                    // this.tagsListNew.forEach((item)=>{
                    //   this.tagsList.push(item);
                    // });
                }).catch((err) => {

                });
            },
        },
    };
</script>
<style scoped lang="less">
    .upload-demo2 {
        display: flex;
    }

    .upload {
        margin-top: 30px;
    }

    .download {
        display: flex;
        align-items: center;
        height: 110px;
    }

    .temUpload,
    .attach {
        display: flex;
        align-items: center;
        height: 50px;
        margin-left: -40px;
    }

    .label {
        font-weight: 500;
        width: 240px;
        text-align: right;
    }

    .file {
        width: 383px;
        height: 38px;
        border: 1px dashed #327c36;
        border-radius: 5px;
        font-size: 14px;
        font-family: Alibaba Sans;
        font-weight: 400;
        color: #327c36;
        line-height: 36px;
        margin: 0 15px;
        text-indent: 0.6em;
    }

    .temUpload .file,
    .attach .file {
        border: 1px solid #e6ebf3;
        color: #999;
    }

    .file span {
        margin-left: 3px;
    }

    .lv,
    .lan {
        width: 118px;
        height: 36px;
        background: #327c36;
        border-radius: 5px;
        font-size: 14px;
        font-family: Alibaba Sans;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
    }

    .lan {
        background: #008dc9;
    }

    .templateDesc {
        margin: 30px 0;
        font-size: 12px;
        font-family: Alibaba Sans;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
    }

    .line {
        width: 701px;
        height: 1px;
        background: #e6ebf3;
    }

    .url_item,
    .items {
        display: flex;
        align-items: center;
    }

    .items {
        margin: 2px 0;
    }

    .url_item {
        flex-wrap: wrap;
    }

    .main {
        position: relative;
        margin-top: -70px;
        z-index: 99;
        width: 100%;
        height: auto;
        background: #fff;
        border-radius: 0 120px 0 0;
    }

    .flexCenter {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /deep/ .el-upload-list {
        // display: none;
    }

    .addUrl {
        cursor: pointer;
    }

    .conner {
        width: 1050px;
        margin: 0 auto;
        text-align: left;
    }

    .flexWrap {
        display: flex;
    }

    .h1 {
        height: 23px;
        font-size: 20px;
        font-family: Alibaba Sans;
        font-weight: bold;
        color: #168ec7;
        line-height: 23px;
        padding-top: 37px;
        padding-bottom: 18px;
    }

    .desc {
        font-size: 11px;
        font-family: Alibaba Sans;
        color: #222222;
        font-weight: 500;
        line-height: 18px;
    }

    .tabList {
        display: flex;
        height: 41px;
        margin-top: 32px;
    }

    .tab {
        flex: 1;
        border: 1px solid #e5e5e5;
        border-radius: 6px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        cursor: pointer;
    }

    .tab.isActive {
        background: linear-gradient(90deg, #144072, #1680b7);
        border-radius: 6px;
        opacity: 1;
        border: 1px solid #ffffff;
        color: #fff;
    }

    .formSubMain {
        background: #fff;
        width: 1050px;
        height: auto;
        margin-bottom: 21px;
        /* border: 2px solid #ebeff4; */
    }
</style>
<style>
    .quill-editor .ql-blank::before {
        font-style: normal !important;
        font-size: 14px !important;
        color: #c0c4cc !important;
    }

    .ql-toolbar {
        display: none !important
    }

    .quill-editor {
        padding: 0 !important;
        font-size: 14px !important;
        font-style: normal !important;
    }

    .ql-container {
        height: 100px !important;
        border: 1px solid #ccc !important;
        font-style: normal !important;
    }

    .el-message {
        background-color: rgba(64, 158, 255, 0.4);
    }

    .el-notification {
        background-color: #e6ebf3 !important;
    }

    .el-form-item__content {
        /*width: 609px; */
        height: auto;
        line-height: 36px;
    }

    .el-form-item__label {
        font-family: Alibaba Sans;
        font-weight: 500;
        color: #333333;
        font-size: 14px;
    }

    .el-input__inner {
        height: 36px;
        border: 1px solid #e6ebf3;
        border-radius: 5px;
        text-align: left !important;
    }

    .el-textarea__inner {
        border: 1px solid #e6ebf3;
        border-radius: 5px;
    }

    .el-form-item {
        display: flex;
        margin: 0;
        justify-content: center;
        margin-top: 11px;
    }

    .el-textarea__inner {
        height: 100%;
    }

    .el-form {
        margin: 30px 0;
    }

    .el-form-item__label {
        width: 120px;
    }

    .QSe {
        display: inline-block;
        font-style: normal;
    }

    .QSe,
    .Add,
    .Rem {
        width: 105px;
        height: 36px;
        background: #168ec7;
        border-radius: 5px;
        text-align: center;
        line-height: 36px;
        color: #fff;
        margin-left: 10px;
        cursor: pointer;
        display: inline-block;
    }

    .QSe {
        line-height: normal !important;
    }

    .Rem {
        background: #cc3300;
    }

    /* .cancel {
    width: 83px;
    height: 33px;
    background: #e6ebf3;
    border-radius: 17px;
    font-family: Alibaba Sans;
    font-weight: bold;
    color: #666666;
    padding: 0 !important;
  }
  .submit {
    width: 83px;
    height: 33px;
    background: #168ec7;
    border-radius: 17px;
    font-size: 14px;
    font-family: Alibaba Sans;
    font-weight: bold;
    color: #ffffff;
    padding: 0 !important;
  } */
    .el-upload--picture-card {
        width: 84px;
        height: 84px;
        line-height: 94px;
    }

    .el-upload-list--picture-card .el-upload-list__item {
        width: 84px;
        height: 84px;
    }

    .el-upload-list--picture-card .el-upload-list__item-actions {
        font-size: 14px;
    }

    .flexWrap .el-upload-list {
        display: none;
    }


    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    /* .objectName .el-input__suffix{} */
</style>

<style lang="less" scoped>
    .el-form-item {
        /deep/ * {
            margin-top: 2px;
        }
    }

</style>